import { AgGridReact } from "ag-grid-react"
import { SBAMultiSelectCheck } from "../../../UiComponents/SBADropDown"
import React, { useEffect, useState, useRef, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { sbaAxios } from "../../../utils/sbaAxios";
import { getactivityType, getTaxEntitiesByContact, getInvestorActivities,getActivityDetails,getAssetNoteDetail,getDocbyActivityId,DownloadDocument } from "../../../../config/apiConfig";
import { getInvestorActivitiesAction } from "../../../actions/investorAccounts";
import moment from "moment";
import { Splitter } from "@progress/kendo-react-layout";
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";
import { Modal } from "react-bootstrap";
export const Activities = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const Gstate = useSelector((state) => state) || {};
    const activities = Gstate?.investorAccounts.InvestorActivitiesDetails || [];
    const activitesGridLoading = useSelector((state) => state.investorAccounts.isInvestorActivitiesDetailsLoading);
    const [activityList, setActivityList] = useState([]);
    const [activityids, setActivityids] = useState([]);
    const [accountList, setAccountList] = useState([]);
    const [accountids, setAccountids] = useState([]);
    const [subject, setSubject] = useState(null);
    const [activitydetail,setActivityDetail]=useState([]);
    const [showModal,setShowModal]=useState(false);
    const [email,setEmail]=useState(false);
    const[emailDetail,setemailDetail]=useState([]);
    const [Documents, setDocuments] = useState([]);
    const [Include, setInclude] = useState(false);
    const endDate = new Date(); 
    const startDate = new Date(); 
    startDate.setMonth(startDate.getMonth() - 2); 
    const formattedStartDate = moment(startDate).format("MM-DD-YYYY");
    const formattedEndDate = moment(endDate).format("MM-DD-YYYY");

    useEffect(() => {
        getActivityList();
       // GetAccountlist();
    }, []);
   
  //  useEffect(() => { getInvestorList(activityids ? activityids : -1, accountids ? accountids:-1); }, []);

    const getActivityList = async () => {
        try {
            const response = await sbaAxios({
                url: `${getactivityType}`,
                method: 'get',
            });
           const types= response?.filter(item => item.ActivityTypeId !== 2)
            setActivityList(types);
            setActivityids(types);
            GetAccountlist(types);
            
        } catch (error) {
            console.error("Error fetching Category List from API:", error);
        }
    };

    const GetAccountlist = async (typedata) => {
        try {
            const response = await sbaAxios({
                url: `${getTaxEntitiesByContact}${params.ContactId}`,
                method: 'get',
            });
            const data = response;
            const Entities = data.length > 1 ? [{
                "TaxEntityId": -1,
                "TaxEntityName": "All"
            }, ...data.sort((a, b) =>
                a.TaxEntityName.localeCompare(b.TaxEntityName))] : [...data.sort((a, b) =>
                    a.TaxEntityName.localeCompare(b.TaxEntityName))];

            const EntityAccount = Entities.map(item => {
                return {
                    "contactId": item.ContactId,
                    "EntityId": item.TaxEntityId,
                    "EntityName": item.TaxEntityName
                };
            });
            setAccountList(EntityAccount);
            setAccountids(EntityAccount);   
            const activityidss = typedata?.filter(item => item.ActivityTypeId !== -1).map(item => item.ActivityTypeId).join(',');
            const accountidss = EntityAccount?.filter(item => item.EntityId !== -1).map(item => item.EntityId).join(',');    
            getInvestorList(activityidss,accountidss)
           
        } catch (error) {
            console.error("Error fetching entities from API:", error);
        }
    }
    const getInvestorList = async (sactivityids, saccountids,subject) => {   
        dispatch(getInvestorActivitiesAction(params.ContactId ? params.ContactId : -1, saccountids ? saccountids : -1, sactivityids ? sactivityids : -1, formattedStartDate, formattedEndDate, -1, subject ? subject:""));
    };

    //on change events
    const handleActivityListChange = (e) => {
        if (e) {
            const currentSelectAll = activityids.some((i) => i.ActivityType === "All");
            const nextSelectAll = e.value.some((i) => i.ActivityType === "All");
            let value = e.value;
            const currentCount = activityids.length;
            const nextCount = value.length;

            if (
                nextCount > currentCount &&
                !currentSelectAll &&
                !nextSelectAll &&
                activityList.length - 1 === nextCount
            ) {
                value = activityList;
            } else if (
                nextCount < currentCount &&
                currentCount === activityList.length &&
                currentSelectAll &&
                nextSelectAll
            ) {
                value = value.filter((v) => v.ActivityType !== "All");
            } else if (!currentSelectAll && nextSelectAll) {
                value = activityList;
            } else if (currentSelectAll && !nextSelectAll) {
                value = [];
            }
            setActivityids(value.length===0?activityids:value);
           const ids= value.length===0?activityids.filter(item => item.ActivityTypeId !== -1).map(item => item.ActivityTypeId).join(','):value?.filter(item => item.ActivityTypeId !== -1).map(item => item.ActivityTypeId).join(',');
           const accids = accountids?.filter(item => item.EntityId !== -1).map(item => item.EntityId).join(',');     
           getInvestorList(ids, accids ? accids : -1);
        }
       
    };
    const handleSubjectChange = (e) => {
        const updatedText = e.target.value;
        setSubject(updatedText);
        const ids= activityids.filter(item => item.ActivityTypeId !== -1).map(item => item.ActivityTypeId).join(',');
        const accids = accountids?.filter(item => item.EntityId !== -1).map(item => item.EntityId).join(',');  
        getInvestorList(ids,accids,updatedText);
    };
    const decodeHTMLEntities = (encodedString) => {
        const encodedHtmlContent = encodeURIComponent(encodedString);
        const src = `data:text/html;charset=utf-8,${encodedHtmlContent}`;
        if (encodedString == undefined)
            return "";
        return src;
    };
    const handleAccountListChange = (e) => {
        if (e) {
            const currentSelectAll = accountids?.some((i) => i.EntityName === "All");
            const nextSelectAll = e.value.some((i) => i.EntityName === "All");
            let value = e.value;
            const currentCount = accountids.length;
            const nextCount = value.length;
            if (
                nextCount > currentCount &&
                !currentSelectAll &&
                !nextSelectAll &&
                accountList.length - 1 === nextCount
            ) {
                value = accountList;
            } else if (
                nextCount < currentCount &&
                currentCount === accountList.length &&
                currentSelectAll &&
                nextSelectAll
            ) {
                value = value.filter((v) => v.EntityName !== "All");
            } else if (!currentSelectAll && nextSelectAll) {
                value = accountList;
            } else if (currentSelectAll && !nextSelectAll) {
                value = [];
            }
            setAccountids(value);
            const typeids= activityids?.filter(item => item.ActivityTypeId !== -1).map(item => item.ActivityTypeId).join(',');
           
           const ids= value?.filter(item => item.EntityId !== -1).map(item => item.EntityId).join(',');    
            getInvestorList(typeids ? typeids : -1, ids);
        }
      
    };
    const dateformat = (params) => {
        const isoDate = params.value;
        return isoDate ? moment(isoDate).format("MM-DD-YYYY") : "";
    }
    const columndef = [
        { headerName: "Activity Type", field: "ActivityType",filter: "agTextColumnFilter" },
        { headerName: "Contact / Account Name ", field: "EntityName",filter: "agTextColumnFilter" },
        { headerName: "Activity Subject", field: "ActivityName",filter: "agTextColumnFilter" },
        { headerName: "Activity Date", field: "ActivityDate", valueFormatter: dateformat,filter: "agTextColumnFilter" },
    ]
    const defaultColDef={sortable: true, filter: true , floatingFilter: true, flex: 1,resizable:true};
    const [panes, setPanes] = React.useState([{
        size: '70%',
        min: '20px',
        collapsible: true
    }, {}, {
        size: '20%',
        min: '20px',
        collapsible: true
    }]);
    const onChange = event => {
        setPanes(event.newState);
    };
    const pdfview = (documentId, documentExtension) => {

        try {
            documentExtension=documentExtension?.toLowerCase();
            if (documentExtension === ".pdf") {
                const encodedDocumentId = btoa(documentId.toString());
                const urls = DownloadDocument + encodedDocumentId;
                sbaAxios({
                    url: urls,
                }).then((response) => {
                    window.open(urls);

                });

            } else if (
                documentExtension === ".xlsx" ||
                documentExtension === ".xls"
            ) {
                const encodedDocumentId = btoa(documentId.toString());
                const urls = DownloadDocument + encodedDocumentId;
                sbaAxios({
                    url: urls,
                   
                }).then((response) => {
                    window.open(urls);

                });
               

            } else if (
                documentExtension === ".png" ||
                documentExtension === ".jpg" ||
                documentExtension === ".jpeg" ||
                documentExtension === ".gif"
            ) {
                const encodedDocumentId = btoa(documentId.toString());
                const urls = DownloadDocument + encodedDocumentId;
                sbaAxios({
                    url: urls,
                }).then((response) => {
                    window.open(urls);

                });
               

            }
            else if (
                documentExtension === ".doc" || documentExtension === ".docx"
            ) {
                const encodedDocumentId = btoa(documentId.toString());
                const urls = DownloadDocument + encodedDocumentId;
                sbaAxios({
                    url: urls,
                }).then((response) => {
                    window.open(urls);

                });
                
            }
            else if (
                documentExtension === ".ppt" || documentExtension === ".pptx"
            ) {
                const encodedDocumentId = btoa(documentId.toString());
                const urls = DownloadDocument + encodedDocumentId;
                sbaAxios({
                    url: urls,    
                }).then((response) => {
                    window.open(urls);

                });
              
            }
        } catch (error) {
            console.error("Error opening document:", error);
        }
    };

    const Preview = () => { 
        return (
        <div class="investors bg-white p-3">
             <div class="attachments bg-white p-3 mt-3">
{Documents?.length === 0 ? (
    <label>No Documents Available </label>
) : (
    Documents?.map((item) => {
        return (
            <div class="card-body p-0">
                <div class="row p-3 border-bottom  m-0">
                    <div class="col-11 left">
                        <span>{item.DocumentName}</span>
                    </div>
                    {
                        <div class="col-1 text-sm-end fw-medium">
                            <span className="SBA_hand">
                                {item.DocumentExtension?.toLowerCase() === ".pdf" ? (
                                    <i
                                        class="fas fa-file-pdf"
                                        style={{ color: "#F40F02" }}
                                        onClick={() =>
                                            pdfview(
                                                item.DocumentId,
                                                item.DocumentExtension
                                            )
                                        }
                                    ></i>
                                ) : item.DocumentExtension?.toLowerCase() === ".xlsx" ||
                                    item.DocumentExtension?.toLowerCase() === ".xls" ? (
                                    <i
                                        class="fas fa-file-excel"
                                        style={{ color: "#1D6F42" }}
                                        onClick={() =>
                                            pdfview(
                                                item.DocumentId,
                                                item.DocumentExtension
                                            )
                                        }
                                    ></i>
                                ) : item.DocumentExtension?.toLowerCase() === ".png" ||
                                    item.DocumentExtension?.toLowerCase() === ".jpg" ||
                                    item.DocumentExtension?.toLowerCase() === ".jpeg" ||
                                    item.DocumentExtension?.toLowerCase() === ".gif" ? (
                                    <i
                                        class="fas fa-file-image"
                                        style={{ color: "#1E3050" }}
                                        onClick={() =>
                                            pdfview(
                                                item.DocumentId,
                                                item.DocumentExtension
                                            )
                                        }
                                    ></i>
                                ) :
                                    item.DocumentExtension?.toLowerCase() === ".doc" ||
                                        item.DocumentExtension?.toLowerCase() === ".docx" ? (
                                        <i
                                            class="fas fa-file-word"
                                            style={{ color: "#2284D9" }}
                                            onClick={() =>
                                                pdfview(
                                                    item.DocumentId,
                                                    item.DocumentExtension
                                                )
                                            }
                                        ></i>
                                    ) : item.DocumentExtension?.toLowerCase() === ".ppt" ||
                                        item.DocumentExtension?.toLowerCase() === ".pptx" ? (
                                        <i
                                            class="fas fa-file-powerpoint"
                                            style={{ color: "#C13B1B" }}
                                            onClick={() =>
                                                pdfview(
                                                    item.DocumentId,
                                                    item.DocumentExtension
                                                )
                                            }
                                        ></i>
                                    ) : (
                                        ""
                                    )}
                            </span>
                        </div>
                    }
                </div>
            </div>
        );
    })
)}
</div>
            {!email ? (
    <div>
        <div className="row">
            <div className="col-md-8">
                <div className="fw-medium">Owner: {activitydetail?.ActivitySource}</div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-8">
                <div className="fw-medium">Created By: {activitydetail?.ActivitySource}</div>
            </div>
        </div>
        <div className="row">
            <div className="col-md-8">
                <div className="fw-medium">Date Created: {moment(activitydetail?.ActivityDate).format("MM-DD-YYYY")}</div>
            </div>
        </div>
    </div>
) :<div>
<div className="row">
    <div className="col-md-8">
        <div className="fw-medium">From: {emailDetail?.EmailFrom}</div>
    </div>
</div>
<div className="row">
    <div className="col-md-8">
        <div className="fw-medium">To: {emailDetail?.EmailTo}</div>
    </div>
</div>
<div className="row">
    <div className="col-md-8">
        <div className="fw-medium">cc: {emailDetail?.EmailCc}</div>
    </div>
</div>
</div> }

                                         
                                            <div className="fw-medium">Subject : {activitydetail?.ActivityName}</div>
                                           
                                            <div className="fw-medium ">Body :</div>
                                            <div >
                                                <iframe
                                                    title="my-iframe"
                                                    width="100%"
                                                    height="500px"
                                                    src={decodeHTMLEntities(activitydetail?.ActivityDescriptionHTML)}
                                                ></iframe>
                                            </div>
    
                                        </div>
        )
        }
    const handleLinkClick = (row) => {
        const ActivityId = row.data.ActivityId;
        if(ActivityId!=0)
        {
            getmultipleDocs(ActivityId);
           getActivityDetailsbyId(ActivityId);
            getDetails(ActivityId);
        }
      
       
       // setShowPreview(true);
    };
    const dbclick=()=>
    {
        setShowModal(true);
    }
    const getActivityDetailsbyId= async (id)=>
    {
        try {
            const response = await sbaAxios({
                url: `${getActivityDetails}${id},${2}`,
                method: 'get',
            })
           
            setemailDetail(response);
            if(response.ActivitySummary.ActivityTypeId===3)
            setEmail(true);
            else
            setEmail(false);
        } catch (error) {
        }
    }
    const getDetails= async(Id)=>
    {
       
        try {
            const response = await sbaAxios({
            url: `${getAssetNoteDetail}${Id}`,
            method: 'get',
        })
        setActivityDetail(response);
      
    }
    catch (error) {
    }
    }
    const getmultipleDocs=async(id)=>
    {
        try {
            const response = await sbaAxios({
            url: `${getDocbyActivityId}${id}`,
            method: 'get',
        })
        setDocuments(response);
    }
    catch (error) {
    }
    }
    const enterclick=(txt)=>
    {
        const ids= activityids.filter(item => item.ActivityTypeId !== -1).map(item => item.ActivityTypeId).join(',');
        const accids = accountids?.filter(item => item.EntityId !== -1).map(item => item.EntityId).join(',');  
        getInvestorList(ids,accids,txt);
    }
    return <>
        <div className="px-4">
            <div className="row">
                <div className="col-md-3">
                    <label
                        className="mb-1 ms-2 fw-semibold fs-12"
                    >
                        Activity Type
                    </label>
                    <div>
                        <SBAMultiSelectCheck
                            className="w-75"
                            data={activityList}
                            value={activityids}
                            dataItemKey="ActivityTypeId"
                            textField="ActivityType"
                            onChange={(e) => { handleActivityListChange(e) }}
                            tags={activityids.length > 0 ?
                                [{ text: `${activityids.length} items selected`, data: [...activityids] }]
                                : []
                            }

                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <label
                        className="mb-1 ms-2 fw-semibold fs-12 d-block"
                    >
                        Accounts
                    </label>
                    <SBAMultiSelectCheck
                        className="w-75"
                        data={accountList}
                        value={accountids}
                        filterable={true}
                        textField="EntityName"
                        dataItemKey="EntityId"
                        tags={accountids.length > 0 ? [{ text: `${accountids.length} items selected`, data: [...accountids] }] : []}
                        onChange={(e) => { handleAccountListChange(e) }}
                    />
                </div>
                <div className="col-md-3 ">
                    <label className="mb-1 ms-2 fw-semibold fs-12">
                        Content
                    </label>
                    <input
                        className="w-75 input-default form-control"
                        type="text"
                        placeholder="Type here"
                        onChange={(e) => { handleSubjectChange(e) }}
                        value={subject}
                   onKeyUp={(e) => { if (e.key === 'Enter') enterclick(subject); }}
                    />
                </div>
                {/*<div className="col-md-3 row-items">*/}
                {/*    <label className="mx-4 fw-semibold fs-12">*/}
                {/*        Include All Accounts*/}
                {/*    </label>*/}
                {/*    <input type="checkbox" defaultChecked={Include} onChange={(e) => { setInclude(value => !value) }} />           */}
                {/*</div>*/}
            </div>
            <div>
                {activitesGridLoading ? (
                    <LoadingScreen />
                ) : (
                    <div className="mx-4 p-3">
                    <div className="row">
                        <Splitter orientation={'vertical'}>
                            <Splitter panes={panes} onChange={onChange}>
                            <div class="col-lg-12 col-md-12">
                    <div className="ag-theme-alpine" style={{ height: '70vh' }}>
                        <AgGridReact
                            rowSelection="single"
                            rowData={activities}
                            columnDefs={columndef}
                            defaultColDef={defaultColDef}
                            onRowClicked={handleLinkClick}
                            onRowDoubleClicked={dbclick}
                           
                        />
                    </div>
                    </div>
                  
                    <div class="col-lg-12 mt-md-2 mt-lg-0">
                                            <div className="preview">
                                               <Preview />
                                            </div>
                                        </div>
                    </Splitter>
                    </Splitter>
                    </div>
                    </div>
                )}
            </div>

            </div>
            <Modal
            show={showModal}
            onHide={() => { setShowModal(false) }}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
        
            <div
                class="modal-dialog modal-dialog-centered modal-dialog-scrollable w-100 " >
                <div class="modal-content p-2 overflow-auto " >
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="DocumentsModalLabel">Mail Preview
                        </h1>
                        <button type="button" class="btn-close" onClick={() => { setShowModal(false) }}
                            aria-label="Close"></button>
                    </div>
                    <form action="#">
                        <div class="modal-body ">
                            <h6 class="fw-medium fs-6 mt-3">
                            </h6>
                           <Preview/>
                        </div>
                    </form>
                </div>
            
           
        </div>
        
            </Modal>
    </>
     
}
